module.exports = __webpack_public_path__ + "static/media/choithramsOrdersG.e27c8330.png";